<div class="btn-group col-12">

  <ng-container *ngFor="let option of props.options | formlySelectOptions : field | async; let i = index">

    <input type="checkbox"
           [id]="id + '_' + i"
           class="btn-check"
           [value]="option.value"
           [checked]="isChecked(option)"
           [disabled]="option.disabled"
           [formlyAttributes]="field"
           (change)="onChange(option.value, $any($event.target).checked)" />
    <label class="btn text-center col p-1"
           [ngClass]="props.class"
           [class.btn-outline-danger]="showError"
           [for]="id + '_' + i"
           [innerHTML]="option.label">
    </label>

  </ng-container>

</div>